import { ReduxAction } from "../../types";
import AgenciesForm from "./AgenciesForm";
import * as Nested from "../../util/Nested";

interface State {}

const initialState: State = {};

export const AGENCIES_FORM_ACTION = "posConfigTool/AGENCIES_FORM_ACTION";
export const agenciesFormAction = Nested.nestedAction(AGENCIES_FORM_ACTION);

const _reducer = (state: State = initialState, { type }: ReduxAction): State => {
  switch (type) {
    default:
      return state;
  }
};

// Raw Redux Maps
export const _mapStateToProps = () => {};
export const _mapDispatchToProps = () => {};

// Nested Redux Maps
const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    forms: {
      agenciesForm: {
        ...AgenciesForm,
        actionType: AGENCIES_FORM_ACTION,
      },
    },
  },
  "agencies"
);

// Nested Reducer
const reducer = (state: State, action: ReduxAction) => nestedReducer(state, action);
export { reducer, mapStateToProps, mapDispatchToProps };
